// components/SwitchButton.js
import { useEffect, useState } from "react";

function SwitchButton({ onChange, defaultState = false }) {
  const [isOn, setIsOn] = useState(defaultState);

  useEffect(() => {
    setIsOn(defaultState);
  }, [defaultState]);

  const toggleSwitch = () => {
    const newState = !isOn;
    setIsOn(newState);
    onChange && onChange(newState);
  };

  return (
    <div
      onClick={toggleSwitch}
      className={`switch-button-container ${isOn ? "on" : "off"}`} // برای استایل‌دهی با CSS
      role="switch"
      aria-checked={isOn}
      title={isOn ? "فعال" : "غیرفعال"}
    >
      <div
        className={`switch-button-knob ${isOn ? "on" : "off"}`} // برای استایل‌دهی با CSS
      ></div>
      <span className="switch-button-status">
        {isOn ? "فعال" : "غیرفعال"}
      </span>
    </div>
  );
}

export default SwitchButton;
